import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { LoginPayload, LoginResponseInterface } from "@/types/auth";

async function doLogin(payload: LoginPayload) {
  return await http.post<APIResponse<LoginResponseInterface>>("auth/signin", payload);
}

async function doInitialize() {
  return await http.post<APIResponse<LoginResponseInterface>>("auth/initialize");
}

async function doLogout() {
  return await http.post<APIResponse<LoginResponseInterface>>("auth/signout");
}

async function doGetAccessPermission() {
  return await http.get<APIResponse<LoginResponseInterface>>("auth/get-access-permission");
}

export default {
  doLogin,
  doInitialize,
  doLogout,
  doGetAccessPermission,
};